// extracted by mini-css-extract-plugin
export default {"inputs":"Inputs_inputs__o++-p"};